<div *ngIf="!showLoading && !showIneligibility" id="customer-eligibility-utf-form">
  <form class="form" [formGroup]="customerEligibility">
    <div *ngIf="!showConfirmedUserRole && !showWorkplaceSection && !showEligibilityCompletion">
      <!-- Affiliation Code Section -->
      <div class="section-block">
        <div class="row no-gutters responder-dropdown">
          <h2 *ngIf="!isPSEAffliationcode">
            {{cfetLabels.cfet_customer_eligibility.utf_select_category_desc}}
          </h2>
          <h2 *ngIf="isPSEAffliationcode">
            {{cfetLabels.cfet_customer_eligibility.utf_select_category_desc}}
          </h2>
        </div>
        <label for="utf-role" id="utf-role">{{cfetLabels.cfet_customer_eligibility.affiliation_heading}}</label>
        <app-message-tooltip class="eligibility-tooltip" [message]="cfetLabels.cfet_customer_eligibility.affiliation_tooltip"></app-message-tooltip>
        <div class="affiliation-wrapper">
          <input type="text" class="form-control aff-input" [formControl]="affiliationCode">
          <button type="button" class="continue-btn" (click)="validateAffiliationCode(affiliationCode.value)"
            [disabled]="continueWithoutAffiliation || isAffiliationCodeValid" [ngClass]="{
          'disabled-btn': continueWithoutAffiliation || isAffiliationCodeValid
        }">
            Continue
          </button>
        </div>
        <!-- Continue Without Code Checkbox -->
        <div class="col-12" id="continue-without-code-container" *ngIf="!hideContinueWithoutCode">
          <label for="continue-without-code" class="checkbox">

            <input id="continue-without-code" tabindex="0" type="checkbox" [(ngModel)]="continueWithoutAffiliation"
              [ngModelOptions]="{standalone: true}" (change)="toggleAffiliationField()" />
            <em class="skin" tabindex="-1"></em>
            <span>
              <p class="checkboxContent"> {{cfetLabels.cfet_customer_eligibility.withoutcode_heading}}
              </p>
            </span>
          </label>
        </div>

        <!-- Description (Show only when checkbox checked) -->
        <div *ngIf="continueWithoutAffiliation" class="without-code-section">
          <p>
            {{cfetLabels.cfet_customer_eligibility.withoutcode_desc}}
          </p>
          <ul>
            <li> {{cfetLabels.cfet_customer_eligibility.withoutcode_desc1}}
            </li>
            <li> {{cfetLabels.cfet_customer_eligibility.withoutcode_desc2}}
            </li>
            <li> {{cfetLabels.cfet_customer_eligibility.withoutcode_desc3}}
            </li>
            <li> {{cfetLabels.cfet_customer_eligibility.withoutcode_desc4}}
            </li>
          </ul>
        </div>

      </div>
      <div id="category-first-section">
        <div class="row no-gutters">
          <div class="col-md-12" id="org-type-section">
            <div class="row no-gutters" id="row-dropdown">
              <div id="category1" class="col-md-12">
                <label for="utf-category"
                  id="utf-category">{{cfetLabels.cfet_customer_eligibility.utf_category}}</label>
                <div class="field-group">
                  <div [ngClass]="checkCategory ? 'dropdown-opened' : ''">
                    <abs-dropdown [drId]="'select_category'" [drName]="'selectCategorydd'"
                      [(dropdownValue)]="categoryValue" formControlName="selectCategory" [disabled]="selectCategory.disabled"
                      [optionRepeat]="categoryList"
                      (dropdownValueChange)="onCategorySelected($event)" (click)="onClickCategory($event)"
                      ngDefaultControl>
                    </abs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="role-second-section">
        <div id="role-section">
          <div class="row no-gutters" id="row-dropdown">
            <div id="role" class="col-md-12">
              <label for="utf-role" id="utf-role">{{cfetLabels.cfet_customer_eligibility.role}}</label>
              <div class="field-group">
                <div [ngClass]="checkRole ? 'dropdown-opened' : ''">
                  <abs-dropdown class="roleDropDown"[drId]="'select_role'" [drName]="'selectRoledd'" [(dropdownValue)]="roleValue"
                    formControlName="selectRole" [disabled]="selectRole.disabled" [optionRepeat]="roleList"
                    (dropdownValueChange)="enableContinue($event)" (click)="onClickRole($event)" ngDefaultControl>
                  </abs-dropdown>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="displayNote && !showWorkplace">
            <div id="note-from-ilm" class="note-from-ilm">
              <p class="note-ilm">{{messageNote}}</p>
            </div>

            <div *ngIf="hideButtons">
              <div id="row-dropdown" class="question-title-column">
                <div *ngFor="let row of selectedJobQuestions; let $index=index;" id="question-container{{$index}}"
                  class="row no-gutters question-container">
                  <div id="select-question-{{$index}}" class="col-12 select-question-{{$index}} ">
                    <p class="selected-role-ques ilm-note">{{row.questionValue}}</p>
                  </div>
                  <div class="col-lg-3 col-6 mobile-styling mr-20"
                    [ngClass]="(selectedconfirmValue[$index]==='Yes' && !showIneligibility) ? 'confirm-checkbox1' : ''">
                    <button class="confirm-btn confirm-btn-mob" id="confirm-btn-yes-{{$index}}-0" tabindex="0"
                      type="button" (click)="roleConfirmYes($event,$index)" (keyup)="roleConfirmYes($event,$index)"
                      [disabled]="showIneligibility">{{cfetButtonLabels.button_labels.yes}}</button>
                  </div>
                  <div id="no-button-{{$index}}" class="col-lg-3 col-6 no-button mobile-styling"
                    [ngClass]="(selectedconfirmValue[$index]==='No' && !showIneligibility) ? 'confirm-checkbox1' : ''">
                    <button class="confirm-btn confirm-btn-mob" id="confirm-btn-no-{{$index}}-0" tabindex="0"
                      type="button" (click)="roleConfirmNo($event,$index)" (keyup)="roleConfirmNo($event,$index)"
                      [disabled]="showIneligibility">{{cfetButtonLabels.button_labels.no}}</button>
                  </div>
                </div>
              </div>

              <div class="col-12" id="qa-container">
                <label for="affirm-checkbox" class="checkbox">
                  <input id="affirm-checkbox" tabindex="0" type="checkbox" (keyup)="confirmCheckboxCheck($event)"
                    [(ngModel)]="showCheckboxQA" [ngModelOptions]="{standalone: true}" [disabled]="showIneligibility" />
                  <em class="skin" tabindex="-1"></em>
                  <span>
                    <p class="checkboxContent">{{cfetLabels.cfet_customer_eligibility.affirm}}</p>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <hr>
          <div class="col-12" class="category-btn-container">
            <a tabindex="0" type="button" id="cancel_link" (click)="cancelApplication($event)"
              (keyup)="cancelApplication($event)">
              <em aria-label=""></em>
              {{cfetButtonLabels.button_labels.cancel}}</a>
            <!-- <button tabindex="0" type="button" id="back-btn" (click)="editCategory()" (keyup)="editCategory()">
              {{cfetButtonLabels.button_labels.back}}</button> -->
            <button tabindex="0" type="button" id="btn-continue" class="btn btn-alt btn-medium"
              (click)="confirmCheckbox($event)" (keyup)="confirmCheckbox($event)"
              [disabled]="!showCheckboxQA || !showConfirmCheckbox || showIneligibility || !isAffiliationValid">
              {{cfetButtonLabels.button_labels.continue}}</button>
          </div>
        </div>
      </div>
      <!-- <div class="dividercomp section" *ngIf="showEligibilityCompletion">
      <div class="row" id="action-divider"></div>
    </div> -->
    </div>
    <div id="role-confirm-section" *ngIf="showConfirmRole || showEligibilityCompletion || showWorkplaceSection">
      <div class="row no-gutters" *ngIf="!showSpinner">
        <div class="col-9 role-mobile-max" *ngIf="showConfirmedUserRole && !showEligibilityCompletion">
          <div class="selected-summary-card">
            <div class="summary-box">
              <div class="summary-label">Organization Type</div>
              <div class="summary-value">{{ selectedCategory }}</div>
            </div>
            <div class="summary-box">
              <div class="summary-label">Current Role</div>
              <div class="summary-value">{{ selectedRole }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <hr *ngIf="!showSpinner"> -->


      <div id="workplace-section"
     *ngIf="showWorkplaceSection || (showWorkplace && isAffiliationFlow)">
        <div class="col-md-12" id="workplace-container">
          <app-customer-eligibility-utf-workplace (eligibilitycompletionstatus)="onEligibilityCompletion($event)"
            (editSelected)="onEditSelection($event)" (workplaceSelected)="hideWorkplaceSection($event)"
            [showWorkplaceSection]="showWorkplaceSection" [showtickicon]="showtickicon" [userType]="userType"
            (stateAndZipPresent)="checkstateAndZip($event)" [stateAndZip]="stateAndZip"  [selectedCategory]="selectedCategory"
  [selectedRole]="selectedRole"
  [selectedconfirmValue]="selectedconfirmValue" 
            (manuallyAddedValues)="hideWorkplaceSection($event)" (savedManualValues)="saveManualValues($event)"
            [manuallyEnteredValues]="manuallyEnteredValues" (showLoadingSpinner)="showLoadingSpinner($event)"
            (showCancelModal)="displayCancelModal($event)" (goToQAndA)="displayQAndA($event)">
          </app-customer-eligibility-utf-workplace>
        </div>
      </div>
    </div>
  </form>
</div>
<div id="ineligibility-section" *ngIf="showIneligibility">
  <div class="row">
    <div class="col-md-12" id="ineligibility-container">
      <app-customer-ineligibility-utf (checkJobRole)="correctEligibleChoice($event)"></app-customer-ineligibility-utf>
    </div>
  </div>
</div>
<abs-modals-and-alerts-component
 *ngIf="showBadCodeModal
    && !continueWithoutAffiliation
    && !showWorkplace
    && !showIneligibility"
 [(modalAction)]="openBadCodeModal"
 (modalClosed)="onBadCodeModalClosed($event)"
 windowClass="modal-docked"
 sizeClass="modal-small">
  <div class="bad-code-modal">
    <abs-modals-and-alerts-content-component>
      <div class="modal-header">
        <h2 class="modal-title">
          {{cfetLabels.cfet_affiliation_code.modal_title}}
        </h2>
        <div class="corner-button">
          <button type="button" class="close-modal-button" (click)="closeBadCodePopup()">
            <em class="icon-close modal-close-icon"></em>
          </button>
        </div>
      </div>
      <div class="modal-body text-center">
        <p>{{cfetLabels.cfet_affiliation_code.modal_desc}}</p>
        <button type="button" id="btn-ok" class="btn btn-alt btn-medium" (click)="openBadCodeModal='close'">
          {{cfetButtonLabels.button_labels.ok}}
        </button>
      </div>
    </abs-modals-and-alerts-content-component>
  </div>
</abs-modals-and-alerts-component>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>
<div [ngClass]=" openPopup? 'open-utf-popup' : 'hide-utf-popup' ">
  <app-firstnet-signup-utf-modal [openModal]="openPopUpUtf">
  </app-firstnet-signup-utf-modal>
</div>
